import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import { SideBar } from "../../components/SideBar";
import ModuleQuestion from "../../components/ModuleQuestion";
import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

// services
import {
  useBookmarkModuleMutation,
} from "../../store/services/moduleServerApi";

const Module_2_1_1 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  // call the service
  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">
              2.4.3 Practice Case 1
            </h1>
            <p className="me-4">Estimated time to complete: 5 minutes</p>
          </section>
          <ModuleQuestion
            correctAnswer="B"
            assessmentName="practice_case_1"
            videoTranscript={
              <>
                <p>
                  <strong>AUDIO</strong>
                  <br />
                  VO: (FEMALE)
                  <br />
                </p>
                <p>
                  This is Practice Case Number 1. This is a negative case. The
                  size and contrast have already been adjusted. In order to
                  interpret this case, we start at the bottom of the brain and
                  move superiorly. As we enter into the cerebellum, there is
                  normal gray-white contrast throughout. Intense uptake is seen
                  in the white matter, surrounded by less intense uptake in the
                  adjacent gray matter. This gray-white contrast can also be
                  seen on the coronal images here. Returning to the transverse
                  images, and moving superiorly, we enter into the temporal and
                  occipital lobes. White matter tracts can be seen on both sides
                  of the brain. This contrast between the gray matter and the
                  white matter is normal. On this particular slice, there may be
                  concern between normal gray and white contrast on both sides
                  within the occipital lobe. In this situation, it is important
                  to look at the slice immediately superior (in this case, this
                  particular slice) and immediately inferior (or this slice) to
                  see if this decrease in gray-white contrast persists. As can
                  be seen, there is normal gray-white contrast on the slice
                  above and below the slice of concern. Therefore, it is
                  important to keep in mind that reduced gray-white contrast
                  should be seen on more than one slice. Moving superiorly and
                  entering the frontal lobes, again, the white matter tracts can
                  be seen delineated on both sides of the brain. Within the
                  frontal lobe, there is good gray-white contrast on both sides.
                  As we enter into the parietal lobes, white matter tracts can
                  again be seen beginning at the front of the brain and moving
                  posteriorly. It is important to review all slices of the
                  brain. And again, there is normal gray-white contrast
                  throughout. This study is negative.
                </p>
              </>
            }
            previousLesson="/module-2/module-2-4-2"
            nextLesson="/module-2/module-2-4-4"
            iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_1820143375&entry_id=1_ycddu8lm&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
            questionType="assessment"
            videoId="1_ycddu8lm"
          />
        </main>
      </div>
    </div>
  );
};

export default Module_2_1_1;
